import styled from 'styled-components';

import { H4 } from '@/components/UI/Typography/Heading';
import { Text } from '@/components/UI/Typography/Text';

export const TitleBar = styled.div<{ isMobile: boolean }>`
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
  min-width: 0;
  flex-direction: ${(p) => (p.isMobile ? 'column' : 'row')};
  font-size: ${(p) => (p.isMobile ? p.theme.fontSizes.md : p.theme.fontSizes.lg)};
  font-weight: 400;

  strong {
    font-weight: 700;
  }

  @media (max-width: 639px) {
    margin-bottom: 16px;

    > span {
      width: 100%;
      min-width: 0;
      text-align: center;
      overflow-wrap: anywhere;
    }
  }
`;

export const EventList = styled.section`
  align-self: start;
  display: grid;
  gap: 12px;
  margin-top: 18px;
  padding: 20px;
  border-radius: ${(p) => p.theme.radii.lg};
  background: ${(p) => p.theme.colors.light};

  @media (max-width: 639px) {
    padding: 20px 12px;
    border-radius: 12px;
  }
`;

export const SectionHeader = styled(H4)`
  margin: 0;
  color: ${(p) => p.theme.colors.primary500};
  font-weight: 700;
`;

export const CalendarLegend = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 14px;
  color: ${(p) => p.theme.colors.gray400};
  font-size: ${(p) => p.theme.fontSizes.sm};
`;

export const LegendItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
`;

export const LegendDot = styled.span<{ $color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${(p) => p.$color};
`;

export const EventCard = styled.article<{ $color?: string }>`
  padding: 14px;
  border-left: 4px solid ${(p) => p.$color || p.theme.colors.secondary500};
  border-radius: ${(p) => p.theme.radii.base};
  background: ${(p) => p.theme.colors.gray000};
`;

export const EventTitle = styled(Text)`
  margin: 0 0 6px;
  color: ${(p) => p.theme.colors.gray500};
  font-weight: 700;
  overflow-wrap: anywhere;
`;

export const EventMeta = styled(Text)`
  margin: 0;
  color: ${(p) => p.theme.colors.gray300};
  overflow-wrap: anywhere;
`;

export const EmptyText = styled(Text)`
  margin: 0;
  color: ${(p) => p.theme.colors.gray300};
`;
